export default __webpack_public_path__ + "static/media/user-circle.030e9d8c.svg";